import { useEffect, useState } from 'react';
import { BellRing, Share, Smartphone, SquarePlus, X } from 'lucide-react';
import { Drawer } from 'vaul';
import { usePushNotifications } from '../hooks/usePushNotifications';
import { dismissAddToHomeScreenPrompt, isAddToHomeScreenPromptDismissed } from './addToHomeScreenPrompt';

export function PwaInstallPromo() {
  const push = usePushNotifications();
  const [open, setOpen] = useState(false);
  const [sessionDismissed, setSessionDismissed] = useState(false);
  const [permanentlyDismissed, setPermanentlyDismissed] = useState(() => isAddToHomeScreenPromptDismissed());

  useEffect(() => {
    if (push.state !== 'install-required' || sessionDismissed || permanentlyDismissed) {
      setOpen(false);
      return undefined;
    }

    const timeout = window.setTimeout(() => setOpen(true), 900);
    return () => window.clearTimeout(timeout);
  }, [permanentlyDismissed, push.state, sessionDismissed]);

  function handleOpenChange(nextOpen: boolean) {
    setOpen(nextOpen);
    if (!nextOpen) setSessionDismissed(true);
  }

  function handleDoNotShowAgain() {
    dismissAddToHomeScreenPrompt();
    setPermanentlyDismissed(true);
    setOpen(false);
  }

  return (
    <Drawer.Root open={open} onOpenChange={handleOpenChange}>
      <Drawer.Portal>
        <Drawer.Overlay className="drawer-overlay" />
        <Drawer.Content className="drawer-content pwa-install-promo-sheet" aria-describedby={undefined}>
          <div className="sheet-handle" aria-hidden="true" />
          <div className="pwa-install-promo-header">
            <div className="pwa-install-promo-icon" aria-hidden="true">
              <BellRing size={28} strokeWidth={2.1} />
            </div>
            <Drawer.Close asChild>
              <button type="button" className="icon-button" aria-label="Close add to home screen reminder">
                <X size={24} strokeWidth={2.2} />
              </button>
            </Drawer.Close>
          </div>

          <div className="pwa-install-promo-copy">
            <Drawer.Title asChild><strong>Get alarm notifications</strong></Drawer.Title>
            <span>Add Chartify to your Home Screen to receive price alarm notifications on this device.</span>
          </div>

          <ol className="pwa-install-steps" aria-label="Add Chartify to Home Screen steps">
            <li>
              <Share size={21} strokeWidth={2} aria-hidden="true" />
              <span>Tap the Safari Share button.</span>
            </li>
            <li>
              <SquarePlus size={21} strokeWidth={2} aria-hidden="true" />
              <span>Choose Add to Home Screen.</span>
            </li>
            <li>
              <Smartphone size={21} strokeWidth={2} aria-hidden="true" />
              <span>Open Chartify from the new icon.</span>
            </li>
          </ol>

          <div className="pwa-install-promo-actions">
            <Drawer.Close asChild>
              <button type="button" className="pwa-install-primary">Got it</button>
            </Drawer.Close>
            <button type="button" className="pwa-install-secondary" onClick={handleDoNotShowAgain}>Don't show again</button>
          </div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
